import { useNavigate } from "react-router-dom";
import MarketingPipeline from "components/more-tools/MarketingPipeline";
import MoreToolCard from "components/more-tools/MoreToolCard";
import { moreToolsTg } from "lib/moreToolsData";
import { PAGE_STORAGE_KEY } from "lib/theme";
import "styles/more-tools.css";

export default function MoreTools() {
  const navigate = useNavigate();

  return (
    <div className="more-tools -mx-4 md:-mx-8">
      <main className="mt-wrap px-4 md:px-8">
        <div className="mb-2 flex justify-end">
          <button
            type="button"
            onClick={() => {
              localStorage.setItem(PAGE_STORAGE_KEY, "front");
              navigate("/");
            }}
            className="flex cursor-pointer items-center gap-2 self-start rounded-md border border-[var(--dash-border)] px-[15px] py-2 text-sm text-[var(--dash-text)] transition-all hover:border-[var(--dash-text-strong)] hover:text-[var(--dash-text-strong)]"
          >
            <i className="fas fa-arrow-left" /> Back to Dashboard
          </button>
        </div>

        <section className="mt-hero">
          <span className="mt-eyebrow">
            <span className="mt-eyebrow-dot" />
            Full Toolkit
          </span>
          <h1>
            The complete Telegram Web <span className="mt-on">Marketing Toolkit</span>.
          </h1>
          <p>
            Every Telegram extension — sending, downloading, translating, and
            protecting — all in one place.
          </p>
        </section>

        <MarketingPipeline />

        <section className="mt-section mt-sec--tg" id="sec-tg">
          <div className="mt-sec-head">
            <span className="mt-sec-bar" />
            <h2>Telegram Web Extensions</h2>
            <span className="mt-tag">{String(moreToolsTg.length).padStart(2, "0")} tools</span>
          </div>
          <div className="mt-grid">
            {moreToolsTg.map((tool, i) => (
              <MoreToolCard key={tool.name} tool={tool} index={i} />
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
